import { ReactNode } from 'react';

import { Box } from '@mantine/core';

import { usePageLoadGlobals } from 'hooks/use-page-load-globals';

import { Page } from './page/Page';

const MaintenancePageWrapper = ({ children }: { children: ReactNode }) => {
    const maintenanceMessage = usePageLoadGlobals()?.maintenanceMessage;

    if (maintenanceMessage) {
        return (
            <Page showBackground hideHeader>
                <Page.CenteredContent title={maintenanceMessage} subtitle="We apologize for the inconvenience.">
                    <Box
                        component="img"
                        width="256"
                        height="256"
                        src="https://img.icons8.com/emoji/256/construction-emoji.png"
                        alt="construction-emoji"
                        style={{
                            width: 128,
                            height: 'auto',
                        }}
                    />
                </Page.CenteredContent>
            </Page>
        );
    }

    return <>{children}</>;
};

export { MaintenancePageWrapper };
